





















































































import "./project-setup.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import ResizableTextarea from "../common/ResizableTextarea.js";
import { Container, Draggable } from "vue-smooth-dnd";
let _ = require("lodash");

export default Vue.extend({
  name: "Checklist",
  components: { Container, Draggable, ResizableTextarea },
  props: {
    card: Object,
    showEditor: Boolean,
  },
  data() {
    return {
      showChecklistEditor: false,
      checklistEditorStyles: {},
      edittingChecklist: null,
      edittingChecklistContent: "",
      showItemEditor: false,
      itemEditorStyles: {},
      edittingItem: null,
      edittingItemContent: "",
      checklists: [
        {
          id: "1",
          title: "My List",
          items: [
            { id: 1, content: "item 1", done: true },
            { id: 2, content: "item 2", done: true },
            { id: 3, content: "item 3", done: false },
          ],
        },
      ],
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: true,
      },
    };
  },
  watch: {
    showModal(newVal) {
      let context = this as any;

      if (newVal === true) {
        let checklists = context.card && context.card.checklists ? context.card.checklists : [];
        context.checklists = checklists.map((checklist) => {
          return Object.assign({}, checklist, {
            items: checklist.items.map((item) => {
              return Object.assign({}, item);
            }),
          });
        });
      }
    },
  },
  computed: {
    ...mapState("project", ["currentProject"]),
    ...mapGetters("project", ["canEditCurrentProject"]),
    showModal(): boolean {
      return this.showEditor;
    },
  },
  methods: {
    getChecklistPayload(checklistId) {
      return (index) => {
        return this.checklists.filter((checklist) => checklist.id === checklistId)[0].items[index];
      };
    },
    onDrop(checklistId, dropResult) {
      let checklist = this.checklists.filter((checklist) => checklist.id === checklistId)[0];
      checklist.items = this.applyDrag(checklist.items, dropResult);
    },
    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      return result;
    },
    handleSave($event) {
      let context = this as any;
      this.$emit("save", context.checklists, $event);
    },
    handleAddOrEditChecklist(checklist, $event) {
      this.edittingChecklist = checklist;
      this.edittingChecklistContent = checklist ? checklist.title : "";
      this.getChecklistEditorPosition($event.target.parentElement);
      this.showChecklistEditor = true;
    },
    getChecklistEditorPosition(element) {
      let offsetLeft = 0;
      let offsetTop = 0;
      do {
        if (!isNaN(element.offsetLeft)) {
          offsetLeft += element.offsetLeft - element.scrollLeft;
          offsetTop += element.offsetTop - element.scrollTop;
        }
      } while ((element = element.offsetParent));

      if (offsetLeft < 0) {
        offsetLeft = 0;
      }

      if (offsetTop < 0) {
        offsetTop = 0;
      }

      this.checklistEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };
    },
    handleSaveChecklist() {
      if (this.edittingChecklistContent && this.edittingChecklistContent != "") {
        if (this.edittingChecklist) {
          this.edittingChecklist.title = this.edittingChecklistContent;
        } else {
          this.checklists.push({
            id: this.uuid(),
            title: this.edittingChecklistContent,
            items: [],
          });
        }
      }

      this.showChecklistEditor = false;
    },
    removeChecklist(checklist) {
      for (var i = 0; i < this.checklists.length; i++) {
        if (this.checklists[i] === checklist) {
          this.checklists.splice(i, 1);
        }
      }
    },
    handleCheck(member) {
      member.done = !member.done;
    },
    removeItem(item, checklist) {
      for (var i = 0; i < checklist.items.length; i++) {
        if (checklist.items[i] === item) {
          checklist.items.splice(i, 1);
        }
      }
    },
    handleAddOrEditItem(checklist, item, $event) {
      this.edittingChecklist = checklist;
      this.edittingItem = item;
      this.edittingItemContent = item ? item.content : "";
      this.getItemEditorPosition($event.target.parentElement);
      this.showItemEditor = true;
    },
    getItemEditorPosition(element) {
      let offsetLeft = 0;
      let offsetTop = 0;
      do {
        // if ((" " + element.className + " ").indexOf(" card-scene ") > -1) {
        //   break;
        // }

        if (!isNaN(element.offsetLeft)) {
          offsetLeft += element.offsetLeft - element.scrollLeft;
          offsetTop += element.offsetTop - element.scrollTop;
        }
      } while ((element = element.offsetParent));

      if (offsetLeft < 0) {
        offsetLeft = 0;
      }

      if (offsetTop < 0) {
        offsetTop = 0;
      }

      this.itemEditorStyles = {
        left: `${offsetLeft}px`,
        top: `${offsetTop}px`,
        position: "absolute",
      };
    },
    handleSaveItem() {
      if (this.edittingItemContent && this.edittingItemContent != "") {
        if (this.edittingItem) {
          this.edittingItem.content = this.edittingItemContent;
        } else {
          this.edittingChecklist.items.push({
            id: this.uuid(),
            content: this.edittingItemContent,
            done: false,
          });
        }
      }

      this.edittingChecklist.addItem = false;
      this.showItemEditor = false;
    },
    getPercentage(checklist) {
      return checklist && checklist.items && checklist.items.length > 0 ? Math.round((checklist.items.filter((item) => item.done === true).length / checklist.items.length) * 100) : 0;
    },
    uuid() {
      // Public Domain/MIT
      var d = new Date().getTime(); //Timestamp
      var d2 = (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16; //random number between 0 and 16
        if (d > 0) {
          //Use timestamp until depleted
          r = (d + r) % 16 | 0;
          d = Math.floor(d / 16);
        } else {
          //Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0;
          d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
      });
    },
  },
});
